import { TrashIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TwoColumnsCardSidebar from '@teetsh/app/src/components/TwoColumnsCardSidebar';
import Button from '@teetsh/app/src/components/Buttons/Button';
import 'twin.macro';
import DeleteAccountModal from '@teetsh/app/src/containers/UserSettings/Compte/DeleteAccount/DeleteAccountModal';

export function RemoveAccount() {
  const [isDeleteAccountOpen, setDeleteAccountOpen] = useState<boolean>(false);
  const { t } = useTranslation(['userSettings']);
  return (
    <>
      <DeleteAccountModal
        isOpen={isDeleteAccountOpen}
        onClose={() => setDeleteAccountOpen(false)}
      />
      <TwoColumnsCardSidebar.Section
        title={t('userSettings:account.director.title')}
      >
        <div tw="mb-4">
          <p>{t('userSettings:account.director.description1')}</p>
          <p>{t('userSettings:account.director.description2')}</p>
        </div>
        <Button
          intent="danger"
          onClick={() => setDeleteAccountOpen(true)}
          icon={TrashIcon}
        >
          {t('userSettings:account.director.cta.removeAccount')}
        </Button>
      </TwoColumnsCardSidebar.Section>
    </>
  );
}
